// src/components/products/sensaphone/SensaphoneIntroduction.jsx
import React from "react";
import RichTextRenderer from "../../common/RichTextRenderer";
import ProductContainerImage from "../ProductContainerImage";
import {
  PRODUCT_DETAIL_BODY_TEXT,
  PRODUCT_DETAIL_CONTENT_WRAP,
} from "../../../utils/productDetailTypography";

const SensaphoneIntroduction = ({
  title,
  content,
  image,
  safeText,
}) => {
  if (!title) return null;

  const firstImage = image && image[0];

  return (
    <div className="mb-12 md:mb-16">
      <div className="product-panel-elevated rounded-3xl shadow-2xl overflow-hidden">
        {/* Introduction Title Bar */}
        <div className="product-panel-header">
          <h2>
            {safeText(title)}
          </h2>
        </div>

        {/* Introduction Content */}
        <div className="p-6 sm:p-8 lg:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12">
            {/* Left: Content */}
            <div className={PRODUCT_DETAIL_CONTENT_WRAP}>
              {content && (
                <>
                  {Array.isArray(content) ? (
                    <RichTextRenderer
                      content={content}
                      textColorClass="text-gray-800"
                      linkColorClass="text-blue-600 hover:text-blue-800 underline text-lg lg:text-xl"
                      bodyTextClass={PRODUCT_DETAIL_BODY_TEXT}
                      compactHeadings
                    />
                  ) : (
                    <div
                      className={`${PRODUCT_DETAIL_BODY_TEXT} whitespace-pre-line text-gray-700`}
                    >
                      {safeText(content)}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Right: Image */}
            {firstImage?.url && (
              <div className="flex items-center justify-center">
                <ProductContainerImage
                  src={firstImage.url}
                  alt={safeText(
                    firstImage?.alternativeText ||
                      firstImage?.name ||
                      "Introduction"
                  )}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SensaphoneIntroduction;





